// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Countdown from 'react-countdown-now';
import Link from '@material-ui/core/Link';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
import LeaderBoard from './LeaderBoard';

import People from './People';
import * as challengePeople from '../challenge_people.json';

import moment from 'moment-timezone';

const Completionist = () => <span>Challenge has completed!</span>

const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
        // Render a completed state
        return <Completionist />;
    } else {
        // Render a countdown
        return <span>{days} days {hours}h {minutes}m {seconds}s</span>;
    }
};

const styles = (theme) => ({
    title: {
        marginTop: '5em'
    },
    overview: {
        marginTop: '2em'
    },
    headings: {
        marginTop: '1em'
    },
    ulItems: {
        paddingLeft: '1.2em'
    },
    preParent: {
        backgroundColor: '#eee',
        border: '1px solid #ddd',
        borderRadius: '2px',
        '& pre': {
            whiteSpace: 'pre-wrap',
        },
        '& span': {
            padding: '1em',
        },
        '& code': {
            fontSize: '12px',
            color: '#000'
        }
    },
    evalAILink: {
        wordBreak: 'break-word'
    },
    teaserImage: {
        width: '100%',
    },
    spanTypography: {
        display: 'inline-block'
    },
    bannerLogo: {
        width: '100%'
    },
    sectionHeader: {
        marginTop: '0.35em'
    },
    evalaiLogo: {
        marginLeft: '-3px'
    }
});

const Challenge2021 = (props) => {
    const deadline = moment.tz("2019-05-27T23:59:59", "Etc/GMT").toDate();
    return (
        <Grid
            container
            justify="center"
            alignItems="center"
        >
            <Grid
                item
                xs={10}
                md={8}
                lg={7}
            >
                <Grid
                    container
                    justify="flex-start"
                    alignItems="flex-start"
                    spacing={16}
                >
                    <Grid item className={props.classes.title} xs={12}>
                        <Typography variant="h3" align="left">
                            LVIS Challenge 2021
                        </Typography>
                    </Grid>


                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h4" align="left">
                            Overview
                        </Typography>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                        Today, rigorous evaluation of general purpose object detectors is mostly performed in the limited category regime (e.g.
                        80) or when there are a large number of training examples
                        per category (e.g. 100 to 1000+). LVIS provides an opportunity to enable research in the setting where there are a large
                        number of categories and where per-category data is sometimes scarce.
                        </Typography>
                        <Typography variant="subtitle1" className={props.classes.headings} align="left">
                            Given that state-of-the-art deep learning methods for object detection perform poorly
                            in the low-sample regime, we believe that our dataset poses an important and exciting
                            new scientific challenge.
                        </Typography>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h4" align="left">
                            Workshop Schedule
                        </Typography>
                        <Typography variant="subtitle1" className={props.classes.headings} align="left">
                            We look forward to seeing everyone on Saturday, October 16th from 8:00 AM to 12:00 PM Pacific Time (PDT).
                            <br/>
                            <b>A complete video recording of the workshop is now <Link href="https://www.youtube.com/watch?v=uAFHd9MapBM">available</Link>.</b>
                            <br/>
                        </Typography>
                        <Table striped bordered hover size="sm">
                            <TableHead>
                                <TableRow>
                                <TableCell>Time in <b>PDT</b></TableCell>
                                <TableCell>Event</TableCell>
                                <TableCell>Speakers</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>8:00 AM - 8:15 AM</TableCell>
                                    <TableCell>Welcome</TableCell>
                                    <TableCell>Agrim Gupta</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>8:15 AM - 9:00 AM</TableCell>
                                    <TableCell>Keynote: "The Impact of Dataset and Model Bias"</TableCell>
                                    <TableCell>Prof. Judy Hoffman, Georgia Tech</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>9:00 AM - 9:20 AM</TableCell>
                                    <TableCell>Overview of new metrics: AP Fixed and Boundary AP</TableCell>
                                    <TableCell>Achal Dave and Bowen Cheng</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>9:20 AM - 9:25 AM</TableCell>
                                    <TableCell>Announcement of results</TableCell>
                                    <TableCell>Ross Girshick</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>9:25 AM - 9:45 AM</TableCell>
                                    <TableCell>Analysis of results</TableCell>
                                    <TableCell>Daniel Bolya</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>9:45 AM - 10:00 AM</TableCell>
                                    <TableCell>Invite challenge winner talk #1</TableCell>
                                    <TableCell>Team BUPT-PRIV_ICA, presented by Lu Yang</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>10:00 AM - 10:15 AM</TableCell>
                                    <TableCell>Coffee break</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>10:15 AM - 10:30 AM</TableCell>
                                    <TableCell>Invite challenge winner talk #2</TableCell>
                                    <TableCell>Team SSSSS, presented by Lin Song</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>10:30 AM - 11:15 AM</TableCell>
                                    <TableCell>Keynote: "Babies, bodies and learning to recognize objects"</TableCell>
                                    <TableCell>Prof. Linda Smith, Indiana University</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>11:15 AM - 11:30 AM</TableCell>
                                    <TableCell>Invited research talk</TableCell>
                                    <TableCell>Team OSU MLB, presented by Cheng Zhang</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>11:30 AM - 11:40 AM</TableCell>
                                    <TableCell>Invited challenge winner talk #3 (pre-recorded video)</TableCell>
                                    <TableCell>Team FuXi-Fresher</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>11:40 AM - 12:00 PM</TableCell>
                                    <TableCell>Panel discussion: metrics, rules, the future of LVIS</TableCell>
                                    <TableCell>Panel</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h5" align="left">
                        Challenge Results
                        </Typography>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                        The awards committee selected team FuXi-Fresher as the winner basedon their overall 
                        AP. They have also been given the "most innovative" award for their observation of how
                        model exponential moving average (EMA) can improve AP for rare categories.
                        Click on a team name to access their tech report.
                        <p>
                            <b>AP†:</b> refers to the <em>experimental</em> "boundary, fixed AP" used in the 2021 challenge.
                        </p>
                        </Typography>

                        <LeaderBoard year={2021}/>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h5" align="left">
                        Important Updates
                        </Typography>
                        
                        <Typography variant="subtitle1" className={props.classes.headings} align="left">
                            <ul>
                                <li><b>Update September 1, 2021: ImageNet-22k pretraining is permitted!</b>
                                <p>We have decided to allow "ImageNet-22k" as pretraining data in the 2021 LVIS Challenge.
                                Note that "ImageNet-22k" is not precisely defined. It is sometimes called "ImageNet-21k" and in various uses is filtered
                                down to 10k or 11k categories. All of these variants are permitted. We take "ImageNet-22k" to mean using any subset of the
                                "14,197,122 images, 21841 synsets indexed" that were produced by the ImageNet project. Note that only the classification
                                labels are permitted, no localization annotations are allowed.</p></li>
                            </ul>
                        </Typography>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h5" align="left">
                        Timeline
                        </Typography>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                            <ul>
                                <li><b>August 18, 2021:</b> The <Link href="https://eval.ai/web/challenges/challenge-page/1114/overview">evaluation server</Link> is now open</li>
                                <li><b>September 27, 2021 (end-of-day anywhere on Earth):</b> Submission deadline</li>
                            </ul>
                        </Typography>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h5" align="left">
                        Changes Relative to the 2020 Challenge
                        </Typography>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                            <b>The evaluation metric has changed compared to last year.</b> The differences are: 
                            <ol>
                                <li>We will use <Link href="https://arxiv.org/abs/2103.16562">Boundary AP</Link> instead of Mask AP.</li>
                                <li>There is <b>no limit</b> on the number of detections <em>per image</em>.</li>
                                <li>There is <b>a new limit</b> of 10,000 detections <em>per category</em> over the entire 20k image evaluation set (i.e., val, test-dev, or test).</li>
                            </ol>
                            <p>
                                Change (1) increases IoU sensitivity to errors made near mask boundaries and removes Mask IoU's bias towards high values on large objects,
                                as described in <Link href="https://arxiv.org/abs/2103.16562">"Boundary IoU: Improving Object-Centric Image Segmentation Evaluation"</Link> by Cheng et al.
                            </p>
                            <p>
                                Changes (2) and (3) implement "Fixed AP" introduced in <Link href="https://arxiv.org/abs/2102.01066">"Evaluating Large-Vocabulary Object 
                                Detectors: The Devil is in the Details"</Link> by Dave et al. This improvement removes a gamability flaw caused by limiting the number of detections per image.
                            </p>
                            <p>
                                These changes are implemented in the <b>lvis_challenge_2021 branch</b> of the <Link href="https://github.com/lvis-dataset/lvis-api/tree/lvis_challenge_2021">lvis-api github repository</Link>.                                
                                Use:
                                <p>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<code className={props.classes.codeText}> {`LVISEval(..., mode="challenge2021")`}</code> 
                                </p>
                                for evaluation (<Link href="https://github.com/lvis-dataset/lvis-api/blob/lvis_challenge_2021/test_challenge21.py">example code</Link>, <Link href="https://github.com/lvis-dataset/lvis-api/blob/84ac272f9167820173ddecb30585ada97d378efe/lvis/eval.py#L24-L26">docs</Link>).
                                You will want to modify your inference code to implement a limit on the number of detections per category in order to avoid excessively large results files.
                            </p>
                        </Typography>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h5" align="left">
                        Rules and Awards
                        </Typography>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                        Please review the rules. They are <em>same</em> as the 2020 challenge rules.
                        <ol>
                            <li> <b>Model ensembles are not permitted.</b> It is difficult to define precisely what constitutes an ensemble, 
                            so use your best judgement. A clear example of an ensemble is training multiple independent models and 
                            combining their results. If unsure, it's likely not permitted, but at the very least carefully
                             describe what you did in your tech report.</li>
                            <li> <b>Use of external annotations is not permitted with one exception (updated September 1, 2021): 
                                any subset of the "14,197,122 images, 21841 synsets indexed" that were produced by the ImageNet project
                                and their classification labels are allowed.</b>
                                <ul>
                                    <li>The LVIS validation set is consider a source of "external annotations". Training on the union of the train set and the validation set is <b>not permitted</b>.</li>
                                    <li>Using other annotation data, such as COCO annotations, OpenImages annotations,
                                        ImageNet localization/detection annotations, etc. is <b>not</b> permitted.</li>
                                    <li><b>Using additional images and videos without annotations is permitted.</b>
                                        The spirit of this rule is to enable the use of unsupervised and semi-superivsed learning techniques.
                                    </li>
                                </ul>
                                </li> 
                            <li>Participants must submit a technical report that includes a detailed ablation study 
                                of their submission (suggested length 1-4 pages). The reports will be made public. 
                                Only submissions with the report will be considered for any award and will be put 
                                in the LVIS leaderboard. We will provide submission instructions in the near future.</li>
                            <li>We will have two different award types: <em>best result</em> and <em>most innovative</em>.
                                The most innovative award will be based on the method description 
                                in the submitted technical reports and decided by the LVIS awards committee. <b>The committee 
                                will invite teams to present at the workshop based on well-documented innovations 
                                rather than simply best scores</b>.</li>
                            <li>There will be a best technical report award for the most innovative and successful solution across.
                                The winner will be determined by the workshop organization committee.</li>
                            <li>While not a binding rule, you should also see <Link href="https://www.lvisdataset.org/bestpractices">best practices</Link> for working with LVIS.</li>
                        </ol>
                        </Typography>
                    </Grid>

                    <Grid item className={props.classes.overview} xs={12}>
                        <Typography variant="h5" align="left">
                        Evaluation Server
                        </Typography>

                        <Typography variant="subtitle1" className={props.classes.headings}  align="left">
                        The Challenge evaluation server is now live at <Link href="https://eval.ai/web/challenges/challenge-page/1114/overview">LVIS Challenge 2021</Link>.
                        {/* Results on the test-dev set (for tech reports) can be computed by submitting results to the <Link href="https://evalai.cloudcv.org/web/challenges/challenge-page/675/overview">LVIS v1.0 Evaluation Server</Link>. */}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

      )
}

export default withStyles(styles)(Challenge2021);
